import dataService from "../../../helpers/dataService";

/**
 * Vérifie si un allocataire peut être inscrit à une EP et récupère son historique
 * @param {string} allocataireId - ID de l'allocataire
 * @returns {Promise} Promise qui résout avec { resultatsRules: { ok, raison }, epHistorique }
 */
export const verifyEpInscription = (allocataireId) => {
  return new Promise((resolve, reject) => {
    dataService.post(
      "eps/verifier-inscription",
      { allocataireId },
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      },
    );
  });
};
